'use client';
import * as Styled from './styled';
import Link from 'next/link';
import * as Icon from '@/ui/Icon';
import { Simple as Tooltip } from '@/ui/Tooltip';
import { RenderHeaderCellProps } from 'react-data-grid';
import { ColumnWithDType } from '../../types';
import TextareaAutosize from 'react-textarea-autosize';
import { TRenderAsEnum } from '../../DataGrid/lib';

import { Row } from '@/ui/primatives';

const DetailsEditor: React.FC<{ value: any; onChange: (value: string) => void }> = ({ value, onChange }) => {
  return (
    <TextareaAutosize
      style={{ width: '100%', padding: 10, border: 'none', borderRadius: 5, resize: 'none', background: 'none' }}
      value={value || ''}
      placeholder="NULL"
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export const Details: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    field: ColumnWithDType;
    value: string;
    rootPath?: string;
    onChange?: (value: string | null) => void;
  }
> = ({ field, value, rootPath, onChange, ...rest }) => {
  const entryRootPath = `${rootPath}`;
  const entryPath = [entryRootPath, value].join('/');

  return onChange ? (
    <DetailsEditor value={value} onChange={onChange} />
  ) : (
    <Styled.LinkDetails {...rest}>
      <Row alignItems="center" gap={20}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <Link href={`/${entryPath}`} className="link">
          <span>{value}</span>
        </Link>
      </Row>
    </Styled.LinkDetails>
  );
};

export const Cell: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { field: ColumnWithDType; value: string; renderAs: TRenderAsEnum }
> = ({ field, value, renderAs, ...rest }) => {
  const entryRootPath = `${field?.fileRootPath}`;
  const entryPath = [entryRootPath, value].join('/');

  return (
    <Styled.LinkCell {...rest}>
      <Row alignItems="center" gap={20}>
        <Link href={`/${entryPath}`} className="link">
          <span>{value}</span>
        </Link>
      </Row>
    </Styled.LinkCell>
  );
};

export const Header: React.FC<RenderHeaderCellProps<any>> = (props) => {
  const field = props.column as ColumnWithDType;
  const renderFunction = field?.metadata?._oxen?.render;
  return (
    <Row alignItems="center" justifyContent="space-between" gap={10}>
      <span>{props.column.name}</span>
      {renderFunction && renderFunction.func && (
        <Tooltip content={`The content in the cell is derived from the custom "${renderFunction.func}" renderer`}>
          <Icon.QuestionCircle />
        </Tooltip>
      )}
    </Row>
  );
};
